<template>
  <div>
    <vue-element-loading :active="isLoading" />
    <v-card>
      <v-card-title>
        <span class="me-3">{{ $t('pages.on_route_trips') }}</span>
        <v-spacer></v-spacer>
      </v-card-title>
      <v-card-text>
        <!--        <div class="row">-->
        <div class="tracking-div">
          <!--          <div class="col-md-4">-->
          <div class="tracking-rides">
            <v-autocomplete
              v-model="bus_id"
              :items="buses"
              item-text="name"
              item-value="id"
              clearable
              dense
              outlined
              :label="$t('pages.buses')"
            ></v-autocomplete>
            <div v-if="rides.length === 0" class="text-center py-5">
              <v-icon size="100" class="py-10">mdi-bus-alert</v-icon>
              <h3>{{ $t('pages.no_on_route_trips') }}</h3>
            </div>
            <div v-else style="max-height: 600px" class="scroll">
              <div
                class="list-group-item py-2 my-2"
                v-for="element in rides"
                :key="element.id"
              >
                <div
                  class="d-flex align-center"
                  style="justify-content: space-between"
                >
                  <!-- Klikimi mbi emrin e con harten te ai autobus. Vetem
                       lexon gjendjen; nuk prek sondazhin as pozicionet. -->
                  <div
                    class="d-flex align-center bus-jump"
                    @click="shkoTeBusi(element)"
                  >
                    <v-icon size="30" class="mr-2">mdi-bus</v-icon>
                    <div
                      class="font-weight-bold text-dark m-1 my-1"
                      v-if="element.bus"
                    >
                      {{ element.bus.name }}
                    </div>
                    <div class="font-weight-bold text-dark m-1 my-1" v-else>
                      -
                    </div>
                  </div>
                  <v-btn
                    type="button"
                    small
                    depressed
                    color="error"
                    dense
                    v-if="!element.finished_at"
                    @click="stopRide(element)"
                    :loading="stopRideLoading === 'loading-' + element.id"
                  >
                    Stop
                  </v-btn>
                </div>
                <div class="text-dark m-1 my-1 ml-1" v-if="element.driver">
                  <v-icon size="25" class="mr-2">mdi-account-tie-hat</v-icon>
                  {{ element.driver.name }}
                </div>
                <div class="text-dark m-1 my-1 ml-1" v-else>
                  <v-icon size="25" class="mr-2">mdi-road-variant</v-icon>-
                </div>
                <div class="text-dark m-1 my-1 ml-1">
                  <v-icon size="25" class="mr-2">
                    mdi-clock-time-four-outline
                  </v-icon>
                  {{ element.started_at | moment('DD/MM/YYYY') }} -
                  {{ element.started_at | moment('HH:mm') }}
                </div>
                <div class="text-dark m-1 my-1 ml-1">
                  <v-icon size="25" class="mr-2"> mdi-clock-time-four </v-icon>
                  <span v-if="element.finished_at">
                    {{ element.finished_at | moment('DD/MM/YYYY') }}
                  </span>
                  -
                  <span v-if="element.finished_at">
                    {{ element.finished_at | moment('HH:mm') }}
                  </span>
                </div>
              </div>
            </div>
          </div>
          <!--          <div class="col-md-8">-->
          <div class="tracking-map">
            <div class="tile-selector">
              <button v-for="s in tileStyles" :key="s.key" class="tile-btn"
                :class="{ active: tileStyle === s.key }" @click="tileStyle = s.key">{{ s.label }}</button>
            </div>
            <l-map
              style="height: 350px; border-radius: 14px; overflow: hidden;"
              :zoom="zoom"
              :center="center"
              ref="mymap"
            >
              <l-tile-layer :url="url" :attribution="attribution"></l-tile-layer>
              <l-marker
                v-for="(location, index) in busesLocation"
                :key="location.ride.id"
                :lat-lng="ankora(location)"
                :ref="`location-${location.ride.id}`"
              >
                <l-icon :icon-size="busIconSize(busLabel(location))" :icon-anchor="busIconAnchor(busLabel(location))" :icon-url="busIcon(location.ride && location.ride.bus_id, busLabel(location))"></l-icon>
                <l-tooltip>
                  {{ $t('pages.bus') }}: <span v-if="location.ride.bus">{{ location.ride.bus.name }}</span><br />
                  {{ $t('pages.driver') }}: <span v-if="location.ride.bus">{{ location.ride.driver.name }}</span><br />
                  {{ $t('pages.started_at') }}:
                  <span v-if="location.ride.started_at">{{ location.ride.started_at | moment('DD/MM/YYYY HH:mm') }}</span>
                  <span v-else>-</span>
                </l-tooltip>
              </l-marker>
            </l-map>

            <!-- Students side panel -->
            <transition name="sp">
              <div v-if="studentsDialog" class="students-panel">
                <div class="sp-header">
                  <div class="sp-header-left">
                    <v-icon color="white" size="18" class="mr-2">mdi-bus-side</v-icon>
                    <div>
                      <p class="sp-sub">{{ selectedRide && selectedRide.driver ? selectedRide.driver.name : '-' }}</p>
                      <p class="sp-title">{{ selectedRide && selectedRide.bus ? selectedRide.bus.name : '-' }}</p>
                    </div>
                  </div>
                  <button class="sp-close" @click="studentsDialog = false">
                    <v-icon color="white" size="18">mdi-close</v-icon>
                  </button>
                </div>

                <div v-if="studentsLoading" class="sp-loading">
                  <v-progress-circular indeterminate color="#e65100" size="32"></v-progress-circular>
                </div>

                <div v-else-if="rideStudents.taken.length === 0 && rideStudents.dropped.length === 0" class="sp-empty">
                  <v-icon size="36" color="#ccc">mdi-account-off-outline</v-icon>
                  <p>Nuk ka nxenes</p>
                </div>

                <div v-else class="sp-body">
                  <div v-if="rideStudents.taken.length > 0">
                    <div class="sp-section-label sp-taken-label">
                      <v-icon small color="#388E3C">mdi-check-circle</v-icon>
                      NE AUTOBUS ({{ rideStudents.taken.length }})
                    </div>
                    <div class="sp-student" v-for="s in rideStudents.taken" :key="'t'+s.id">
                      <div class="sp-avatar sp-avatar-green">
                        <v-icon size="16" color="#388E3C">mdi-account</v-icon>
                      </div>
                      <div class="sp-student-info">
                        <p class="sp-student-name">{{ s.name }}</p>
                        <p class="sp-student-time" v-if="s.taken_at">
                          <v-icon size="12" color="#94a3b8">mdi-clock-outline</v-icon>
                          Marre: {{ s.taken_at | moment('HH:mm') }}
                        </p>
                      </div>
                    </div>
                  </div>
                  <div v-if="rideStudents.dropped.length > 0" class="mt-2">
                    <div class="sp-section-label sp-dropped-label">
                      <v-icon small color="#1976D2">mdi-home-circle</v-icon>
                      ZBRITUR ({{ rideStudents.dropped.length }})
                    </div>
                    <div class="sp-student" v-for="s in rideStudents.dropped" :key="'d'+s.id">
                      <div class="sp-avatar sp-avatar-blue">
                        <v-icon size="16" color="#1976D2">mdi-account</v-icon>
                      </div>
                      <div class="sp-student-info">
                        <p class="sp-student-name">{{ s.name }}</p>
                        <p class="sp-student-time" v-if="s.dropped_at">
                          <v-icon size="12" color="#94a3b8">mdi-clock-outline</v-icon>
                          Zbritur: {{ s.dropped_at | moment('HH:mm') }}
                        </p>
                      </div>
                    </div>
                  </div>
                </div>

                <div class="sp-footer">
                  <span>Gjithsej: {{ rideStudents.total }} nxenes</span>
                  <button class="sp-refresh" @click="openRideStudents(selectedRide)" :disabled="studentsLoading">
                    <v-icon size="14" color="#e65100">mdi-refresh</v-icon>
                    Rifresko
                  </button>
                </div>
              </div>
            </transition>
          </div>
        </div>
        <!--        <div class="row">-->
        <!--          <div-->
        <!--            v-if="on_route_trips.length === 0"-->
        <!--            class="col-md-4 text-center py-10"-->
        <!--          >-->
        <!--            <v-icon size="100" class="py-10">mdi-bus-alert</v-icon>-->
        <!--            <h3>No on-route trips</h3>-->
        <!--          </div>-->
        <!--          <div v-else class="col-md-4">-->
        <!--            <div-->
        <!--              class="list-group-item py-6 my-2"-->
        <!--              :class="selectedIdx == index ? 'active-stop' : ''"-->
        <!--              v-for="(element, index) in on_route_trips"-->
        <!--              :key="element.id"-->
        <!--              @click="-->
        <!--                selectedItem = element.channel;-->
        <!--                selectedIdx = index;-->
        <!--              "-->
        <!--            >-->
        <!--              <div v-if="element.driver" class="d-flex align-center">-->
        <!--                <v-icon size="30" class="mr-2">mdi-bus</v-icon>-->
        <!--                <div class="font-weight-bold text-dark m-1 my-1">-->
        <!--                  {{ element.driver.name }}-->
        <!--                </div>-->
        <!--              </div>-->
        <!--              <div-->
        <!--                class="text-dark m-1 my-1 ml-1"-->
        <!--                v-if="element.trip && element.trip.route"-->
        <!--              >-->
        <!--                <v-icon size="25" class="mr-2">mdi-road-variant</v-icon>-->
        <!--                {{ element.trip.route.name }}-->
        <!--              </div>-->
        <!--              <div class="text-dark m-1 my-1 ml-1">-->
        <!--                <v-icon size="25" class="mr-2"-->
        <!--                  >mdi-clock-time-four-outline</v-icon-->
        <!--                >-->
        <!--                {{ element.started_at }}-->
        <!--              </div>-->
        <!--            </div>-->
        <!--          </div>-->
        <!--          <div class="col-md-8" id="map">-->
        <!--            <GoogleMapLoader-->
        <!--              :enabled="false"-->
        <!--              :center="center"-->
        <!--              :selected="selectedItem"-->
        <!--              :zoom="zoom"-->
        <!--              :apiKey="apiKey"-->
        <!--              :markers="markers"-->
        <!--              :polylines="polyline"-->
        <!--            >-->
        <!--            </GoogleMapLoader>-->
        <!--          </div>-->
        <!--        </div>-->
      </v-card-text>
    </v-card>

  </div>
</template>

<script>
// $(window).scroll(function () {
//   $("#map")
//     .stop()
//     .animate(
//       {
//         marginTop: $(window).scrollTop() + "px",
//         marginLeft: $(window).scrollLeft() + "px",
//       },
//       "slow"
//     );
// });

import GoogleMapLoader from '../../components/GoogleMapLoader.vue';
import { mesazhiIGabimit } from '@/utils/error-message';
import VueElementLoading from 'vue-element-loading';
// Levizja e autobusit midis dy pozicioneve, qe te mos kerceje.
import { glideTo } from '@/utils/marker-glide';
import { busIcon, busIconSize, busIconAnchor } from '@/utils/bus-icon';
import { Keys } from '/src/config.js';

export default {
  components: {
    GoogleMapLoader,
    VueElementLoading,
    Keys,
  },
  data() {
    return {
      // apiKey: Keys.GOOGLE_MAPS_API_KEY,
      // markers: [],
      // selectedIdx: null,
      // currentPlace: null,
      // on_route_trips: [],
      // directions: [],
      // polyline: [],
      // center: {
      //   lat: Keys.VUE_APP_ORIGIN_LAT,
      //   lng: Keys.VUE_APP_ORIGIN_LNG,
      // },
      // zoom: 12,
      // selectedItem: null,
      // submiting: false,
      // mode: null, //0: create, 1 edit
      isLoading: false,
      tileStyle: ['satellite', 'standard', 'esri', 'terrain'].includes(localStorage.getItem('mapTileStyle'))
        ? localStorage.getItem('mapTileStyle')
        : 'satellite',
      tileStyles: [
        { key: 'satellite', label: 'Satelit' },
        { key: 'standard',  label: 'Standard' },
        { key: 'esri',      label: 'Esri' },
        { key: 'terrain',   label: 'Terrain' },
      ],
      attribution:
        // '&copy; <a target="_blank" href="http://osm.org/copyright">OpenStreetMap</a> contributors',
        '',
      zoom: 11,
      center: [42.6526173, 21.1464795],
      markerLatLng: [42.6526173, 21.1464795],
      buses: [],
      bus_id: null,
      rides: [],
      busesLocation: [],
      hasFitBounds: false,
      pollInterval: null,
      stopRideLoading: null,
      studentsDialog: false,
      studentsLoading: false,
      selectedRide: null,
      rideStudents: { taken: [], dropped: [], total: 0 },
    };
  },
  mounted() {
    // Ankorat e markuesve. Jashte `data` qe te mos jene reaktive.
    this.ankorat = {};

    // this.center.lat = parseFloat(this.center.lat);
    // this.center.lng = parseFloat(this.center.lng);
    this.fetchOnRouteTrips();
    this.getAllBuses();
    this.getAllRides();
    this.getLocations();
    // Rifreskimi: nje udhetim mund te ndalet nga shoferi ose vetvetiu nga
    // sistemi, pa e ditur kjo faqe. Pa kete, shenja e autobusit mbetej ne
    // harte aty ku u ndal, derisa ringarkohej faqja.
    // (Me pare therritej `getRideBuses()`, qe nuk ekziston ketu.)
    this.pollInterval = setInterval(() => this.getAllRides(this.bus_id, true), 15000);
    const map = this.$refs.mymap.mapObject;
    map.addControl(new window.L.Control.Fullscreen());
    map.removeControl(map.attributionControl);
  },
  computed: {
    url() {
      const tiles = {
        satellite: 'https://server.arcgisonline.com/ArcGIS/rest/services/World_Imagery/MapServer/tile/{z}/{y}/{x}',
        standard:  'https://{s}.tile.openstreetmap.org/{z}/{x}/{y}.png',
        esri:      'https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}',
        terrain:   'https://{s}.tile.opentopomap.org/{z}/{x}/{y}.png',
      };
      return tiles[this.tileStyle] || tiles.satellite;
    },
  },
  methods: {
    /**
     * Pozicioni me te cilin lidhet shablloni — i pandryshueshem.
     *
     * Kthen gjithmone te njejtin varg per nje udhetim, ndaj vue2-leaflet nuk
     * e prek me markuesin pas krijimit dhe levizjen e zoteron `glideTo`.
     * Dyqani mbahet jashte `data`: po te ishte reaktiv, do te shkaktonte
     * riperpunim ne cdo kornize te animacionit.
     */
    ankora(location) {
      // Shablloni renderohet para `mounted`, ndaj dyqani krijohet ketu nese
      // ende nuk ekziston.
      if (!this.ankorat) this.ankorat = {};

      const id = location && location.ride ? location.ride.id : undefined;
      if (id === undefined) return location ? location.coordinates : undefined;

      if (!this.ankorat[id]) this.ankorat[id] = location.coordinates;
      return this.ankorat[id];
    },
    /**
     * E con harten te autobusi i zgjedhur nga lista.
     *
     * Vetem lexim: nuk prek `busesLocation`, as sondazhin, as degjuesit e
     * websocket-it. `hasFitBounds` eshte tashme i vertete ne kete moment,
     * ndaj perqendrimi automatik nuk e zhvendos me harten pas ketij klikimi.
     */
    shkoTeBusi(ride) {
      const vendi = this.busesLocation.find((l) => l.ride && l.ride.id === ride.id);

      if (!vendi || !vendi.coordinates) {
        this.$notify({
          title: this.$t('pages.bus'),
          text: this.$t('messages.no_position_yet'),
          type: 'warn',
        });
        return;
      }

      const map = this.$refs.mymap && this.$refs.mymap.mapObject;
      if (!map) return;

      map.setView(vendi.coordinates, Math.max(map.getZoom(), 16), { animate: true });

      // Shenja e atij autobusi hapet, qe te dallohet nga te tjerat.
      const shenja = this.$refs[`location-${ride.id}`];
      const objekti = Array.isArray(shenja) ? shenja[0] : shenja;

      if (objekti && objekti.mapObject && objekti.mapObject.openTooltip) {
        objekti.mapObject.openTooltip();
      }
    },

    fitMapToBuses() {
      if (!this.busesLocation.length || this.hasFitBounds) return;
      this.hasFitBounds = true;
      const map = this.$refs.mymap?.mapObject;
      if (!map) return;
      const coords = this.busesLocation.map(l => l.coordinates);
      if (coords.length === 1) {
        map.setView(coords[0], 14);
      } else {
        map.fitBounds(coords, { padding: [50, 50], maxZoom: 14 });
      }
    },
    addBusIcon(on_route_trip) {
      const position = {
        lat: parseFloat(on_route_trip.last_position_lat),
        lng: parseFloat(on_route_trip.last_position_lng),
      };
      let infoText = this.getTripInfoText(on_route_trip);

      let marker = {
        place_id: on_route_trip.channel,
        position: position,
        infoText: infoText,
      };
      //change the marker icon to school bus
      const image = 'https://cdn-icons-png.flaticon.com/32/3471/3471521.png';
      marker.icon = image;
      this.markers.push(marker);
    },
    getTripInfoText(on_route_trip, speed = null) {
      let infoText = '';
      if (on_route_trip.driver) {
        infoText += '<b>Driver:</b> ' + on_route_trip.driver.name + '<br/>';
      }
      if (on_route_trip.trip && on_route_trip.trip.route) {
        infoText += '<b>Route:</b> ' + on_route_trip.trip.route.name + '<br/>';
      }
      if (speed) {
        infoText += '<b>Speed:</b> ' + speed + ' km/h<br/>';
      }
      return infoText;
    },
    //API Calls
    fetchOnRouteTrips() {
      this.submiting = true;
      axios
        .get('/planned-trips/on-route')
        .then((response) => {
          this.submiting = false;
          this.on_route_trips = response.data.running;
          if (this.on_route_trips.length > 0) {
            for (let index = 0; index < this.on_route_trips.length; index++) {
              this.addBusIcon(this.on_route_trips[index]);
            }
            this.listenToChannels();
          }
        })
        .catch((error) => {
          this.submiting = false;
          // Rifreskim ne sfond: pa njoftim. Perdoruesi nuk kerkoi asgje, dhe me
          // nje lidhje te dobet keto kuti grumbulloheshin cdo 15 sekonda.
          console.warn('Rifreskimi dështoi:', mesazhiIGabimit(error));
          this.$router.go(-1);
          //this.$swal("Error", error.response.data.message, "error");
        });
    },
    listenToChannels() {
      for (let index = 0; index < this.on_route_trips.length; index++) {
        this.listenToChannel(index, this.on_route_trips[index]);
      }
    },
    listenToChannel(index, trip) {
      window.Echo.channel(trip.channel).listen('TripPositionUpdated', (e) => {
        if (this.selectedItem == trip.channel) {
          //update the marker position
          let data = e.data;
          //parse the data as json
          data = JSON.parse(data);
          let lat = data.lat;
          let lng = data.lng;
          //convert lat and lng to float if they are strings
          lat = parseFloat(lat);
          lng = parseFloat(lng);
          let speed = data.speed;
          //approximate the speed to 2 decimal places
          speed = Math.round(speed * 100) / 100;
          let position = {
            lat: lat,
            lng: lng,
          };
          let marker = this.markers[index];
          marker.position = position;
          let infoText = this.getTripInfoText(trip, speed);
          marker.infoText = infoText;
          this.center = position;
          this.selectedItem = null;
          //delay some time
          setTimeout(() => {
            this.selectedItem = trip.channel;
          }, 10);
        }
      });
    },
    getAllBuses() {
      axios
        .get('/buses/list')
        .then((response) => {
          this.buses = response?.data;
        })
        .catch((error) => {
          this.buses = [];
          // Rifreskim ne sfond: pa njoftim. Perdoruesi nuk kerkoi asgje, dhe me
          // nje lidhje te dobet keto kuti grumbulloheshin cdo 15 sekonda.
          console.warn('Rifreskimi dështoi:', mesazhiIGabimit(error));
          this.$swal('Error', error.response.data.message, 'error');
        });
    },
    /**
     * @param {number|null} bus_id   kufizimi ne nje autobus, kur eshte zgjedhur
     * @param {boolean} heshtur      pa mbulesen e ngarkimit, per rifreskimin periodik
     */
    getAllRides(bus_id, heshtur = false) {
      if (!heshtur) this.isLoading = true;
      axios
        .get('/rides', { params: { bus_id } })
        .then((response) => {
          this.rides = response?.data;
          // Nje autobus mund te kete disa udhetime brenda dites. Shenja vendoset
          // ne pozicionin e tanishem te autobusit, ndaj udhetimet e perfunduara
          // do te jepnin disa shenja identike, njera mbi tjetren. Ne harte dalin
          // vetem ato qe jane ende ne rruge; lista majtas i mban te gjitha.
          const neRruge = (this.rides || []).filter((r) => !r.finished_at);

          this.busesLocation = this.busesLocation.filter((l) => neRruge.some((r) => r.id === l.ride?.id));
          if (neRruge.length > 0) {
            neRruge.map((ride) => {
              const location = {
                ride,
                coordinates: [
                  ride?.bus?.latitude ?? 42.6664358,
                  ride?.bus?.longitude ?? 21.1175278,
                ],
              };

              const index = this.busesLocation.findIndex(
                (item) => item.ride?.id === location.ride?.id
              );

              if (index !== -1) {
                this.busesLocation[index] = location;
              } else {
                this.busesLocation.push(location);
              }

              // this.timer = setInterval(() => {
              this.busesLocation = this.busesLocation.map((l) => {
                const lat = Number(l.coordinates[0]);
                const lng = Number(l.coordinates[1]);

                if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
                  console.warn('Invalid coords for', l.ride.id, l.coordinates);
                  return l;
                }

                return {
                  ...l,
                  coordinates: [lat, lng],
                };
              });

              this.$nextTick(() => {
                for (const l of this.busesLocation) {
                  const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
                  glideTo(cmp?.mapObject, l.coordinates);
                }
                this.fitMapToBuses();
              });

              // this.timer = setInterval(() => {
              //   console.log('called');
              //   this.busesLocation = this.busesLocation.map((m) => {
              //     const [lat, lng] = m.coordinates;
              //     const jitter = (Math.random() - 0.5) * 0.02;
              //     return {
              //       ...m,
              //       coordinates: [lat + jitter, lng + jitter], // REPLACE with a new array
              //     };
              //   });
              // }, 2000);
            });
          } else {
            this.busesLocation = [];
          }
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error fetching rides',
            type: 'error',
          });
          // this.$swal('Error', error.response.data.message, 'error');
        })
        .then(() => {
          this.isLoading = false;
        });
    },
    getLocations() {
      window.Echo.private(`bus-location`).listen('.location-updated', (e) => {
        // this.getAllRides(this.bus_id);

        if (!!this.bus_id && this.bus_id !== e.ride?.bus_id) {
          return;
        }

        const newRide = { ...e };
        newRide.coordinates = Object.values(newRide.coordinates);

        const index = this.busesLocation.findIndex(
          (item) => item.ride?.id === newRide.ride?.id
        );

        if (index !== -1) {
          this.busesLocation[index] = newRide;
        } else {
          return;
          this.busesLocation.push(newRide);
        }

        this.busesLocation = this.busesLocation.map((l) => {
          const lat = Number(l.coordinates[0]);
          const lng = Number(l.coordinates[1]);

          if (!Number.isFinite(lat) || !Number.isFinite(lng)) {
            console.warn('Invalid coords for', l.ride.id, l.coordinates);
            return l;
          }

          return {
            ...l,
            coordinates: [lat, lng],
          };
        });

        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            glideTo(cmp?.mapObject, l.coordinates);
          }
        });
      });
      window.Echo.private(`bus-location-refresh`).listen(
        '.location-refresh',
        (e) => {
          this.getAllRides(this.bus_id);
        }
      );
    },
    busIcon,
    busIconSize,
    busIconAnchor,

    /** Numri ose emri i shkurter i autobusit, i shfaqur nen shenje. */
    busLabel(location) {
      const emri = location && location.ride && location.ride.bus && location.ride.bus.name;
      if (!emri) return '';
      // Vetem numri kur emri eshte si "Autobusi 3"; perndryshe tre shkronjat e para.
      const numri = String(emri).match(/\d+/);
      return numri ? numri[0] : String(emri).slice(0, 3);
    },
    stopRide(ride) {
      this.stopRideLoading = 'loading-' + ride.id;
      axios
        .post(`/rides/${ride.id}/school-stop`)
        .then(() => {
          this.$notify({
            title: 'Success',
            text: 'Success stoping ride',
            type: 'success',
          });
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Error stoping ride',
            type: 'error',
          });
        })
        .then(() => {
          this.stopRideLoading = null;
        });
    },
    openRideStudents(ride) {
      if (!ride) return;
      this.selectedRide = ride;
      this.studentsDialog = true;
      this.studentsLoading = true;
      this.rideStudents = { taken: [], dropped: [], total: 0 };
      axios
        .get(`/rides/${ride.id}/students-school`)
        .then((response) => {
          this.rideStudents = response.data;
        })
        .catch(() => {
          this.$notify({
            title: 'Error',
            text: 'Gabim gjatë ngarkimit të nxënësve',
            type: 'error',
          });
          this.studentsDialog = false;
        })
        .then(() => {
          this.studentsLoading = false;
        });
    },
  },
  watch: {
        tileStyle(val) { localStorage.setItem('mapTileStyle', val); },
    bus_id: {
      handler: function (newVal, oldVal) {
        this.getAllRides(newVal);
      },
      deep: true,
    },

    busesLocation: {
      handler() {
        this.$nextTick(() => {
          for (const l of this.busesLocation) {
            const cmp = this.$refs[`location-${l.ride.id}`]?.[0];
            if (cmp?.mapObject) {
              cmp.mapObject.off('click');
              cmp.mapObject.on('click', () => this.openRideStudents(l.ride));
              const el = cmp.mapObject.getElement();
              if (el) el.style.cursor = 'pointer';
            }
          }
        });
      },
      deep: true,
    },
  },
  beforeDestroy() {
    clearInterval(this.pollInterval);
    clearInterval(this.timer);
  },
};
</script>

<style>
.flip-list-move {
  transition: transform 0.5s;
}

.no-move {
  transition: transform 0s;
}

.ghost {
  opacity: 0.5;
  background: #c8ebfb;
}

.list-group {
  min-height: 20px;
}

.list-group-item {
  cursor: pointer;
}

.list-group-item i {
  cursor: pointer;
}

.v-application ul {
  padding-left: 12px !important;
}

.gm-style .gm-style-iw-d {
  color: #0d508b !important;
}
</style>

<style lang="scss">
.active-stop {
  background: rgba($primary-shade--light, 0.15) !important;
}

.scroll {
  overflow: scroll;
  scrollbar-gutter: stable;
}

.tracking-div {
  width: 100%;
  display: flex;
  flex-direction: row;
  gap: 15px;
}

.tracking-map {
  flex: 0 0 65%;
  position: relative;
  z-index: 0;
}

.tracking-rides {
  flex: 0 0 35%;
}

@media (max-width: 700px) {
  .tracking-div {
    flex-direction: column;
  }

  .tracking-map,
  .tracking-rides {
    flex: 0 0 100%;
  }
}

hr.divider {
  border-top: 1px solid #bbbb;
  border-radius: 25px;
  margin: 10px 7px;
  opacity: 0.5;
}

/* Leaflet controls must stay below Vuetify dialog */
.tracking-map .leaflet-top,
.tracking-map .leaflet-bottom,
.tracking-map .leaflet-control-container {
  z-index: 1 !important;
}


/* ── Students side panel ── */
.students-panel {
  position: absolute;
  top: 0;
  right: 0;
  width: 270px;
  height: 350px;
  background: #fff;
  z-index: 9999;
  display: flex;
  flex-direction: column;
  box-shadow: -4px 0 24px rgba(0,0,0,0.18);
  border-radius: 0 0 0 14px;
  overflow: hidden;
}
.sp-header {
  background: linear-gradient(135deg, #BF360C, #e65100);
  padding: 12px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  flex-shrink: 0;
}
.sp-header-left {
  display: flex;
  align-items: center;
}
.sp-sub {
  font-size: 10px;
  color: rgba(255,255,255,0.8);
  margin: 0;
  font-weight: 500;
}
.sp-title {
  font-size: 14px;
  font-weight: 800;
  color: #fff;
  margin: 0;
}
.sp-close {
  background: rgba(255,255,255,0.2);
  border: none;
  border-radius: 6px;
  width: 26px;
  height: 26px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  flex-shrink: 0;
}
.sp-loading {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: center;
}
.sp-empty {
  flex: 1;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  color: #94a3b8;
  font-size: 13px;
  gap: 8px;
}
.sp-body {
  flex: 1;
  overflow-y: auto;
  padding: 8px 0;
}
.sp-section-label {
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: 10px;
  font-weight: 700;
  letter-spacing: 0.5px;
  padding: 6px 14px 4px;
}
.sp-taken-label { color: #388E3C; background: rgba(56,142,60,0.06); }
.sp-dropped-label { color: #1976D2; background: rgba(25,118,210,0.06); }
.sp-student {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 7px 14px;
}
.sp-avatar {
  width: 30px;
  height: 30px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}
.sp-avatar-green { background: rgba(56,142,60,0.12); }
.sp-avatar-blue  { background: rgba(25,118,210,0.12); }
.sp-student-info { flex: 1; min-width: 0; }
.sp-student-name {
  font-size: 13px;
  font-weight: 600;
  color: #1a2744;
  margin: 0;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}
.sp-student-time {
  font-size: 11px;
  color: #64748b;
  margin: 2px 0 0;
  display: flex;
  align-items: center;
  gap: 3px;
}
.sp-footer {
  border-top: 1px solid rgba(0,0,0,0.08);
  padding: 8px 14px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 11px;
  color: #64748b;
  flex-shrink: 0;
}
.sp-refresh {
  background: none;
  border: none;
  cursor: pointer;
  font-size: 11px;
  color: #e65100;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 3px;
}
.sp-refresh:disabled { opacity: 0.5; cursor: default; }
/* Slide-in transition */
.sp-enter-active, .sp-leave-active { transition: transform 0.22s ease, opacity 0.22s; }
.sp-enter, .sp-leave-to { transform: translateX(100%); opacity: 0; }

.tile-selector {
  display: flex;
  gap: 6px;
  margin: 8px 0;
  overflow-x: auto;
  flex-wrap: nowrap;
  padding-bottom: 2px;
  -webkit-overflow-scrolling: touch;
  scrollbar-width: none;
}
.tile-selector::-webkit-scrollbar { display: none; }
.tile-btn {
  padding: 5px 14px;
  border-radius: 20px;
  border: 1.5px solid #ccc;
  background: #fff;
  font-size: 12px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.15s;
  color: #444;
  white-space: nowrap;
  flex-shrink: 0;
}
.tile-btn:hover { border-color: #F57C00; color: #F57C00; }
.tile-btn.active { background: #F57C00; color: #fff; border-color: #F57C00; }

.tracking-map .leaflet-container { touch-action: none; z-index: 0; isolation: isolate; }
.leaflet-control-attribution { display: none !important; }

/* Emri i autobusit eshte i klikueshem: e tregojme edhe me kursorin. */
.bus-jump {
  cursor: pointer;
  border-radius: 8px;
  padding: 2px 6px;
  margin-left: -6px;
  transition: background-color 0.15s;
}

.bus-jump:hover {
  background: rgba(0, 0, 0, 0.05);
}
</style>